import { find, go, some } from 'fxjs/es';
import { isAfter } from 'date-fns';

export const CharacterValidatorS = {
  findSelectedCharacter: (characters) => find(({ is_selected }) => is_selected, characters),

  hasCollaborationItems: (avatar_items) =>
    go(
      avatar_items,
      some(({ collaboration_flag }) => collaboration_flag),
    ),

  isCollaboCharacter: (character) => {
    if (!character) return;
    const { avatar_items, special_world_character_flag } = character;
    return CharacterValidatorS.hasCollaborationItems(avatar_items) || special_world_character_flag;
  },

  isOldCharacter: (character) => {
    if (!character) return;
    const { date_last_login } = character;

    // 로그기반으로 캐릭터가 수집되는데, 최초 로그 수집일이 23년 12월 21일
    const compareDate = new Date('2023-12-21T00:00:00+00:00');

    return !isAfter(new Date(date_last_login), compareDate);
  },

  isInvalidCharacter: (character) => {
    return CharacterValidatorS.isCollaboCharacter(character) || CharacterValidatorS.isOldCharacter(character);
  },

  strainerInvalidCharacter: (character) => {
    if (CharacterValidatorS.isInvalidCharacter(character)) return null;
    return character;
  },

  compareCharacter: (character1, character2) => {
    return (
      character1.maple_image_url === character2.maple_image_url &&
      JSON.stringify(character1.selected_motions) === JSON.stringify(character2.selected_motions)
    );
  },
};
